function mapGetOneCollateralLogoData(responseData) {
    return {
        ...responseData,
    };
}

function mapGetListCollateralLogosData(responseData) {
    return responseData.map((data) => ({
        ...data,
    }));
}

export { mapGetOneCollateralLogoData, mapGetListCollateralLogosData };
